import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FieldArrayWithId, UseFieldArrayUpdate } from "react-hook-form";

import { SimpleTable } from "../../../common/components/functional/simpleTable/SimpleTable";
import { StyledTableHeadingCell } from "../../../common/components/functional/simpleTable/styled";
import { PricingRow } from "./PricingRow";
import { PricingFormValues } from "./SupplementPricing";

type Props = {
  fields: FieldArrayWithId<PricingFormValues, "prices", "id">[];
  update: UseFieldArrayUpdate<PricingFormValues, "prices">;
};

export const PricingTable = ({ fields, update }: Props) => {
  const { t } = useTranslation();

  return (
    <SimpleTable
      header={
        <TableRow>
          <StyledTableHeadingCell>{t("common:name")}</StyledTableHeadingCell>
          <StyledTableHeadingCell>
            {t("settings:unitValue")}
          </StyledTableHeadingCell>
          <StyledTableHeadingCell>{t("settings:unit")}</StyledTableHeadingCell>
          <StyledTableHeadingCell>
            {t("settings:canOverrideUnitValue")}
          </StyledTableHeadingCell>
        </TableRow>
      }
      items={fields.map((priceList, index) => (
        <PricingRow field={priceList} index={index} update={update} />
      ))}
    />
  );
};
